var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-layout', {
    attrs: {
      "justify-center": ""
    }
  }, [_c('v-responsive', {
    attrs: {
      "max-width": "1280px",
      "width": "100%"
    }
  }, [_c('list-heading', {
    attrs: {
      "title": "".concat(_vm.title, " \uBAA9\uB85D")
    },
    model: {
      value: _vm.showsSearch,
      callback: function callback($$v) {
        _vm.showsSearch = $$v;
      },
      expression: "showsSearch"
    }
  }), _c('v-data-table', {
    staticClass: "my-4 v-sheet--outlined",
    attrs: {
      "items": _vm.requests,
      "headers": _vm.headers,
      "hide-default-footer": "",
      "disable-sort": ""
    },
    scopedSlots: _vm._u([{
      key: "item.area",
      fn: function fn(_ref) {
        var item = _ref.item;
        return [_vm._v(" " + _vm._s(item.area.parent.name) + " / " + _vm._s(item.area.name) + " ")];
      }
    }, {
      key: "item.createdAt",
      fn: function fn(_ref2) {
        var item = _ref2.item;
        return [_vm._v(" " + _vm._s(item.createdAt.toDateTime()) + " ")];
      }
    }, {
      key: "item._requestees.length",
      fn: function fn(_ref3) {
        var item = _ref3.item;
        return [_c('counsels-requestees', {
          attrs: {
            "value": item
          },
          on: {
            "input": _vm.syncItem
          }
        })];
      }
    }, {
      key: "item.isDone",
      fn: function fn(_ref4) {
        var item = _ref4.item;
        return [_c('counsels-toggle-isdone', {
          attrs: {
            "value": item
          },
          on: {
            "input": _vm.syncItem
          }
        })];
      }
    }, {
      key: "item.actions",
      fn: function fn(_ref5) {
        var item = _ref5.item;
        return [_c('counsels-report', {
          attrs: {
            "request": item
          }
        })];
      }
    }], null, true)
  }), _c('v-pagination', {
    staticClass: "my-4",
    attrs: {
      "length": _vm.pageCount,
      "total-visible": 11
    },
    on: {
      "input": function input($event) {
        return _vm.search();
      }
    },
    model: {
      value: _vm.page,
      callback: function callback($$v) {
        _vm.page = $$v;
      },
      expression: "page"
    }
  })], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }